import { useBaseHook } from './useBaseHook'

export const usePost = (API) => {

    const { onApply } = useBaseHook(API)

    const onPost = (reqbody) => onApply("post-operation", reqbody)

    return { onPost }
}
